<template>
    <Docs url="/docs.pdf" />
</template>

<script>
import Docs from '@/components/Docs.vue';

export default {
    name: 'DocsEnglish',
    components: { Docs },
};
</script>